import { Component, OnInit, TemplateRef, Type } from "@angular/core";
import { FUIPopoverContent, FUIPopoverRef } from "./popover-ref";

function assertIsComponentContent<T>(value: unknown,
                                     method: RenderMethod): asserts value is Type<T> {
  if (method === RenderMethod.component && !(value instanceof Type)) {
      throw new Error('To render component you must pass Type<T>!');
  }
}

function assertIsTemplateContent<T>(value: unknown,
                                    method: RenderMethod): asserts value is TemplateRef<T> {
  if (method === RenderMethod.template && !(value instanceof TemplateRef)) {
      throw new Error('To render template you must pass TemplateRef<T>!');
  }
}

function assertIsTextContent(value: unknown,
                             method: RenderMethod): asserts value is string {
  if (method === RenderMethod.text && typeof value !== 'string') {
      throw new Error('To render text you must passe string!');
  }
}

const RenderMethod = {
  template:  'template',
  component: 'component',
  text:      'text'
} as const;
//type ValueOf<T> = T[keyof T];
//type RenderMethod = ValueOf<typeof RenderMethod>;
type RenderMethod = typeof RenderMethod[keyof typeof RenderMethod];

export interface FUIPopoverComponentContext {
    close: (data?: unknown) => void;
}

@Component({
    selector: 'fui-popover',
    templateUrl: './popover.component.html',
    standalone: false
})
export class FUIPopoverComponent implements OnInit {
  public renderMethod: RenderMethod = RenderMethod.component;

  private _content!: FUIPopoverContent;

  public get templateContent(): TemplateRef<any> {
    assertIsTemplateContent(this._content, this.renderMethod);
    return this._content;
  }

  public get componentContent(): Type<any> {
    assertIsComponentContent(this._content, this.renderMethod);
    return this._content;
  }

  public get textContent(): string {
    assertIsTextContent(this._content, this.renderMethod);
    return this._content;
  }

  public context!: FUIPopoverComponentContext;

  constructor(private popoverRef: FUIPopoverRef) { }

  ngOnInit(): void {
    this._content = this.popoverRef.content;
    this.renderMethod = this.renderMethodForContent(this.popoverRef.content);

    if (this.renderMethod === RenderMethod.template) {
      this.context = {
        close: this.popoverRef.close.bind(this.popoverRef)
      }
    }
  }

  private renderMethodForContent(content: FUIPopoverContent): RenderMethod {
    if (typeof content === 'string') {
      return RenderMethod.text;
    }
    if (content instanceof TemplateRef) {
      return RenderMethod.template;
    }
    return RenderMethod.component;
  }
}
